<template>
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1666 1H0.833252L6.16658 7.30667V11.6667L8.83325 13V7.30667L14.1666 1Z"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="icon-filter"
    />
  </svg>
</template>

<script>
export default {}
</script>

<style lang="scss">
#app[data-theme='dark'] {
  .icon-filter {
    stroke: white;
  }
}
</style>
